import * as Yup from "yup";

export const SignUpSchema = (userRole) =>
  Yup.object({
    name: Yup.string()
      .min(3, "Name must be at least 3 characters")
      .max(50, "Name must not exceed 50 characters")
      .required("Please enter your name"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Please enter your email"),
    location: Yup.string()
      .min(2, "Location must be at least 2 characters")
      .max(200, "Location must not exceed 200 characters")
      .required("Please enter your location"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(
        /[@$!%*?&]/,
        "Password must contain at least one special character (@, $, !, %, *, ?, &)"
      )
      .required("Please enter your password"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Please confirm your password"),
    image: Yup.mixed()
      .required("Please upload your profile image")
      .test(
        "fileSize",
        "File too large (max 5MB)",
        (value) => !value || (value && value.size <= 5 * 1024 * 1024)
      )
      .test(
        "fileType",
        "Unsupported file format (only JPG, PNG allowed)",
        (value) =>
          !value ||
          (value &&
            ["image/jpeg", "image/png", "image/jpg"].includes(value.type))
      ),

    experience: Yup.string().when([], {
      is: () => userRole === "artist",
      then: (schema) => schema.required("Experience is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    skills: Yup.array().when([], {
      is: () => userRole === "artist",
      then: (schema) =>
        schema
          .min(1, "Please enter at least 1 skills")
          .max(5, "Please enter at most 5 skills")
          .of(Yup.string().required("Skill cannot be empty")),
      otherwise: (schema) => schema.notRequired(),
    }),

    bio: Yup.string().when([], {
      is: () => userRole === "artist",
      then: (schema) => schema.required("Bio is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
